import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ConfirmModal from '../../../components/ConfirmModal'; // ../../../../ to get back to src/components
import ProfileImage from '../../../components/ProfileImage';
import './IncomingFriendRequests.css'; // Reusing the CSS from its sibling

const SentFriendRequests = ({ requests, onCancel }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const navigate = useNavigate();

    const openModal = (user) => {
        setSelectedUser(user);
        setModalOpen(true);
    };

    const handleConfirm = () => {
        if (selectedUser) {
            onCancel(selectedUser._id);
        }
        setModalOpen(false);
    };

    return (
        <div className="section">
            <div className="list-container">
                {requests.length > 0 ? (
                    requests.map(user => (
                        <div key={user._id} className="friend-row">
                            <div
                                className="friend-avatar-clickable"
                                onClick={() => navigate(`/profile/${user.username}`)}
                            >
                                <ProfileImage
                                    src={user.profilePicture}
                                    alt="avatar"
                                    className="friend-avatar"
                                />
                            </div>

                            <div className="friend-info">
                                <strong>{user.nickname || user.username}</strong>
                                <p>Request sent</p>
                            </div>

                            <div className="friend-actions">
                                <button
                                    className="small-btn danger"
                                    onClick={() => openModal(user)}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    ))
                ) : (
                    <p className="empty-message">No sent requests pending</p>
                )}
            </div>

            <ConfirmModal
                isOpen={modalOpen}
                title="Cancel Request"
                message={`Cancel friend request to ${selectedUser?.nickname || selectedUser?.username}?`}
                onCancel={() => setModalOpen(false)}
                onConfirm={handleConfirm}
            />
        </div>
    );
};

export default SentFriendRequests;